import React, { useContext, useState, FormEvent, useEffect } from "react";
import {
  Tab,
  Grid,
  Popup,
  Button,
  Table,
  Label,
  Form,
  Input,
  Segment,
  Item,
  Dropdown,
  Select,
} from "semantic-ui-react";
import ProjectStore from "../../../app/stores/projectStore";
import ProjectSOREditForm from "./ProjectSOREditForm";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { IProjectTask } from "../../../app/models/projecttask";
import { ITaskAssignment } from "../../../app/models/taskassignment";
import { ITaskTechnician } from "../../../app/models/tasktechnician";
import { ITechnician } from "../../../app/models/technician";
import {RootStoreContext} from '../../../app/stores/rootStore';
import AssignmentForm from "./AssignmentForm";
import LoginForm from '../../user/LoginForm';

const AssignmentTab = () => {
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const projectStore = useContext(ProjectStore);
  const {
    projectsByDate: projectsByDate,
    projecttasksByName: projecttasksByName,
    project,
    selectedProjectTask,
    deleteProject: deleteProject,
    loadProjectTasks: loadProjectTasks,
    createProjectTask,
    deleteProjectTask,
    editProjectTask,
    selectProjectTask,
    loadTaskAssignments,
    getTechnicianInfo,
    updateMember,
    tasktechniciansByCategory: tasktechniciansByCategory,
    techniciansByName: techniciansByName,
    technicianEmail,
    taskassignmentsByCategory,
    deleteTechnicianTask,
    tasktechnicianRegistry,
    submitting,
    editMode,
    target,
  } = projectStore;

  const handleSubmit = () => {
  // tasktechniciansByCategory.map((tt) => assignTechnician(tt));
  };

  return (
    <Tab.Pane clearing>
      {/* <Segment clearing> */}
          <Button onClick={() => openModal(<AssignmentForm />)} color='blue' icon="user" content='Assign Task'/>
        <p> </p>
      <Form onSubmit={handleSubmit}>
          <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width='3'>Item Name</Table.HeaderCell>
              <Table.HeaderCell width='2'>Item Category</Table.HeaderCell>
              <Table.HeaderCell width='2'>Tech Name</Table.HeaderCell>
              <Table.HeaderCell width='1'>Brighten Code</Table.HeaderCell>
              <Table.HeaderCell>Remark</Table.HeaderCell>
              <Table.HeaderCell width='1'>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {taskassignmentsByCategory.map((taskassignment) => (
              <Table.Row key={taskassignment.id}>
                <Table.Cell>
                   {taskassignment.itemName}
                </Table.Cell>
                <Table.Cell>
                {taskassignment.itemCategory}
                </Table.Cell>
                <Table.Cell>{technicianEmail.get(taskassignment.technicianEmail)}</Table.Cell>
                <Table.Cell> {taskassignment.brightenCode}</Table.Cell>
                <Table.Cell>
                {taskassignment.remark}
                </Table.Cell>
                <Table.Cell>
                      <Button
                        name={taskassignment.id}
                        size='mini'
                        // loading={target === tasktechnician.id && submitting}
                //        onClick={() => deleteTechnicianTask(taskassignment.id).then(() => loadTaskAssignments(taskassignment.projectId))}
                        onClick={() => deleteTechnicianTask(taskassignment.id)}
                        content='Delete'
                        color='red'
                      />
                    </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        {/* <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        /> */}
      </Form>

      {/* </Segment> */}
    </Tab.Pane>
  );
};

export default observer(AssignmentTab);
